<template>
  <div>
    <!-- Застройщик -->
    <div class="mb-4">
      <h5 class="mb-2">🏢 {{ $t('residential_complex.complex.details.developer') }}</h5>
      <p v-if="complex.developer">
        <router-link :to="`/public/developers/${complex.developer.id}`">
          {{ complex.developer.name }}
        </router-link>
      </p>
    </div>

    <!-- Локация -->
    <div class="mb-4">
      <h5 class="mb-2">📍 {{ $t('residential_complex.complex.details.location') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-if="complex.country?.name">🌍 {{ $t('residential_complex.complex.details.country') }}: {{ complex.country.name }}</li>
        <li v-if="complex.region?.name">🗺️ {{ $t('residential_complex.complex.details.region') }}: {{ complex.region.name }}</li>
        <li v-if="complex.city?.name">🏙️ {{ $t('residential_complex.complex.details.city') }}: {{ complex.city.name }}</li>
        <li v-if="complex.district?.name">🏡 {{ $t('residential_complex.complex.details.district') }}: {{ complex.district.name }}</li>
      </ul>
    </div>

    <!-- Характеристики комплекса -->
    <div class="mb-4">
      <h5 class="mb-2">📊 {{ $t('residential_complex.complex.details.characteristics') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-if="complex.complex_class">🏷️ {{ $t('residential_complex.complex.details.class') }}: {{ complex.complex_class }}</li>
        <li v-if="complex.buildings_count">🏘️ {{ $t('residential_complex.complex.details.buildings_count') }}: {{ complex.buildings_count }}</li>

        <li v-if="complex.construction_start_date">🧱 {{ $t('residential_complex.complex.details.construction_start') }}: {{ formatDate(complex.construction_start_date) }}</li>
        <li v-if="complex.sales_start_date">🛒 {{ $t('residential_complex.complex.details.sales_start') }}: {{ formatDate(complex.sales_start_date) }}</li>
        <li v-if="complex.construction_end_date">🏗️ {{ $t('residential_complex.complex.details.construction_end') }}: {{ formatDate(complex.construction_end_date) }}</li>
        <li v-if="complex.expected_delivery_date">📦 {{ $t('residential_complex.complex.details.delivery') }}: {{ formatDate(complex.expected_delivery_date) }}</li>
      </ul>
    </div>

    <!-- Инвестиционные показатели -->
    <div class="mb-4">
      <h5 class="mb-2">💸 {{ $t('residential_complex.complex.details.investments_prices') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-if="complex.total_value_available">💼 {{ $t('residential_complex.complex.details.total_value_available') }}: € {{ formatPrice(complex.total_value_available) }}</li>
        <li v-if="complex.min_price">💰 {{ $t('residential_complex.complex.details.price_from') }}: € {{ formatPrice(complex.min_price) }}</li>
        <li v-if="complex.max_price">💶 {{ $t('residential_complex.complex.details.price_to') }}: € {{ formatPrice(complex.max_price) }}</li>
        <li v-if="complex.average_price_per_sqm">📐 {{ $t('residential_complex.complex.details.price_per_sqm') }}: € {{ formatPrice(complex.average_price_per_sqm) }}</li>
        <li v-if="complex.roi_projection">📈 {{ $t('residential_complex.complex.details.roi') }}: {{ (parseFloat(complex.roi_projection) * 100).toFixed(2) }}%</li>
      </ul>
    </div>

    <!-- Удобства -->
    <div class="mb-4">
      <h5 class="mb-2">🏗 {{ $t('residential_complex.complex.details.amenities') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-for="(val, key) in complex.amenities" :key="key" v-if="val">✅ {{ $t(`residential_complex.complex.amenities.${key}`) }}</li>
      </ul>
    </div>

    <!-- Инфраструктура -->
    <div class="mb-4">
      <h5 class="mb-2">🏙 {{ $t('residential_complex.complex.details.infrastructure') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-for="(val, key) in complex.infrastructure" :key="key" v-if="val">🏘️ {{ $t(`residential_complex.complex.infrastructure.${key}`) }}</li>
      </ul>
    </div>

    <!-- Расстояния -->
    <div class="mb-4">
      <h5 class="mb-2">📍 {{ $t('residential_complex.complex.details.distances') }}</h5>
      <ul class="list-unstyled small ps-3">
        <li v-if="complex.distance_to_sea">🌊 {{ $t('residential_complex.complex.details.to_sea') }}: {{ formatMeters(complex.distance_to_sea) }}</li>
        <li v-if="complex.distance_to_center">🏛 {{ $t('residential_complex.complex.details.to_center') }}: {{ formatMeters(complex.distance_to_center) }}</li>
        <li v-if="complex.distance_to_airport">✈️ {{ $t('residential_complex.complex.details.to_airport') }}: {{ formatMeters(complex.distance_to_airport) }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  complex: {
    type: Object,
    required: true
  }
})

const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("ru-RU", {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

const formatPrice = (value) => {
  return Number(value).toLocaleString('ru-RU')
}

const formatMeters = (val) => {
  const num = Number(val)
  return num > 999 ? `${(num / 1000).toFixed(1)} км` : `${num} м`
}
</script>
